import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Components
// import SimpleHeader from '../SimpleHeader'
import Extent from './../../../components/Extent'

// Utils
import { translation } from '../../../../utils/helpers'

// Elements
import Panel from '../../../elements/panel'
import { ReferenceIcons } from '../../../elements/icons'

class ReferenceExtent extends Component {
  render () {
    const { department, orderId } = this.props

    const isPaint = department === 0
    const icon = isPaint ? ReferenceIcons.Extent : null

    return (
      <Panel title={translation('889')} icon={icon}>
        {isPaint && (
          <Extent
            order={orderId}
            department={department}
            extents={[{ type: 'base', editable: false, showEditLink: false }, { type: 'addon', editable: false, showEditLink: false }]}
            key='base'
          />
        )}

        {!isPaint && <label className='full'>{translation('70')}</label>}
        {!isPaint && (
          <Extent
            order={orderId}
            department={department}
            extents={[{ type: 'base', editable: false, showEditLink: false, noTitle: true, combined: true }]}
          />
        )}
      </Panel>
    )
  }
}

ReferenceExtent.propTypes = {
  orderId: PropTypes.number.isRequired,
  department: PropTypes.number.isRequired
}

export default ReferenceExtent



// WEBPACK FOOTER //
// ./src/app/shared/modals/ReferenceOrderActionModal/ReferenceExtent/index.js